'use strict';

export default function limitWordsFilter() {
  return (value, wordLimit = 1) => {
    const words = value.match(/\S+/g) || [''];
    return words.slice(0, wordLimit)[0];
  };
}



// WEBPACK FOOTER //
// ./app/src/filters/limit_words.filter.js